/**
 * What a DirectionalLight3D's `sky_mode` lets it reach. Godot's scene shader and sky shader read a
 * light apart, so a light can light surfaces, draw its sun in the sky, or both.
 */
import { enumNamesByValue } from '../../classdb/enumNames.js';
/** `DirectionalLight3D::SkyMode` (`scene/3d/light_3d.h:172-176`). */
export const DirectionalLightSkyMode = {
    LIGHT_AND_SKY: 0,
    LIGHT_ONLY: 1,
    SKY_ONLY: 2,
};
/** The sky mode names, for a diagnostic that reports the legal values. */
export const DIRECTIONAL_LIGHT_SKY_MODE_NAMES = enumNamesByValue(DirectionalLightSkyMode);
/** `light_storage.cpp:632`: the scene shader skips a Sky Only light, so it lights no surface. */
export function directionalLightLightsSurfaces(skyMode) {
    return skyMode !== DirectionalLightSkyMode.SKY_ONLY;
}
/** `sky.cpp:1069`: the sky shader skips a Light Only light, so it draws no disc in the sky. */
export function directionalLightDrawsInSky(skyMode) {
    return skyMode !== DirectionalLightSkyMode.LIGHT_ONLY;
}
//# sourceMappingURL=directionalLightSkyMode.js.map